import script from "./reloadHint.vue?vue&type=script&setup=true&lang=js"
export * from "./reloadHint.vue?vue&type=script&setup=true&lang=js"

import "./reloadHint.vue?vue&type=style&index=0&id=1fce0c69&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fce0c69"]])

export default __exports__